var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFontSize = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#696E77",
  d: "M1.86 12H.752l3.205-8.727h1.09L8.253 12H7.144L4.536 4.653h-.068zm.41-3.41h4.465v.938H2.27v-.937Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#696E77",
  d: "M13.146 12V3M13 3.354l-2 2m2.293-2 2 2m-2 6.246 2-2M13 11.6l-2-2"
})));
export default SvgFontSize;